import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

// Customer/staff entry point for a table's QR order. GetrestableOrderNum
// only ever returns 0 or 1 open order per table (there's no table-scoped
// closed-order-history endpoint), so a "choose an order" list is a redundant
// tap — hand off straight to QrOrderDetails, which already knows how to find
// or start that table's one running order (fetchExistingOrderForTable /
// claimTable).
//
// tableId/tableNo are resolved from either route param (the customer QR
// link, /pos/qrorder/:tableid?/:tableNo?) or the query string (the staff
// sidebar link, POSSidebar.js:164, /pos/qrorder?tableId=...&tableNo=...) —
// match.params never populates from a query string, so the sidebar link only
// ever worked before by coincidence of its hardcoded value matching this
// component's own fallback.
class QrOrderlist extends Component {

    get tableId() {
        const params = new URLSearchParams(this.props.location?.search || '');
        return this.props.match?.params?.tableId
            || params.get('tableId')
            || '550e8400-e29b-41d4-a716-446655449999';
    }

    get tableNo() {
        const params = new URLSearchParams(this.props.location?.search || '');
        return this.props.match?.params?.tableNo
            || params.get('tableNo')
            || 12;
    }

    render() {
        return <Redirect to={`/pos/qrorder/details/${this.tableId}/${this.tableNo}`} />;
    }
}

export default QrOrderlist;
